import { useMutation } from '@tanstack/react-query'
import { PulseFilters } from 'api/pulse'
import { getTopComplaintsCsv } from 'api/pulse/topComplaints'
import fileDownload from 'js-file-download'
import { track } from 'lib/amplitude'

export function useTopComplaintsDownloadCsv(query: PulseFilters) {
  return useMutation({
    mutationFn: async () => {
      track('button_click, pulse_download_csv_top_complaints', {
        filters: query,
      })
      const data = await getTopComplaintsCsv(query)
      fileDownload(data, 'top_complaints.csv')
    },
  })
}
